
      import { defu } from 'defu'
      const matcher = /* @__PURE__ */ (() => { const $0={payload: true},$1={};; return (m,p)=>{let r=[];if(p.charCodeAt(p.length-1)===47)p=p.slice(0,-1)||"/";if(p==="/"){r.unshift({data:$0});}let s=p.split("/"),l=s.length-1;if(s[1]==="api"){r.unshift({data:$1,params:{"_":s.slice(2).join('/'),}});}return r;}})()
      export default (path) => defu({}, ...matcher('', path).map(r => r.data).reverse())
      